// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"488":"axiom","532":"styles","592":"common","736":"vendor"}[chunkId] || chunkId) + "." + {"241":"2b16e6f66b3aeced94f6","488":"65db565af602f014a571","532":"6a96aa360293e9c3ae7d","592":"ceca12b5b6b1e4a9ef68","736":"96eff708dcdde816dcbf"}[chunkId] + ".js";
};